import { h, Component, Fragment } from 'preact';
import Store from 'store/store';
import * as actions from 'components/utils/actions';
import { joinClasses } from 'utils/utils';
import { navigateInternally } from 'utils/bolt';

import Button from 'components/bolt/button/button';

import s from 'components/bolt/modalAdvert/modalAdvert.sss';

export default class ModalAdvert extends Component {
	render(props) {
		const { image, type, appData } = props;
		const copy = appData?.copy?.siteCopy;
		const title = type === 'shop' ? copy?.shopModalTitle : copy?.donateModalTitle;
		const content = type === 'shop' ? copy?.shopModalContent : copy?.donateModalContent;
		const cta = type === 'shop' ? copy?.shopModalCTA : copy?.donateModalCTA;
		const imgAlt = type === 'shop' ? copy?.shopModalImageAlt : copy?.donateModalImageAlt;
		const imgSrc = type === 'shop' ? `${__IMAGE_ROOT__}/popup_corner_shop.webp` : `${__IMAGE_ROOT__}/popup_corner_donate.webp`;
		return (
			<div class={joinClasses(s.wrap, type === 'shop' && s.shop)}>
				<div class={s.content}>
					<h2>{title}</h2>
					<p>{content}</p>
					<Button
						trigger={() => {
							Store.emit('TRACK_MODAL_CTA_CLICK', { type: type === 'shop' ? 'store' : 'donate' });
							navigateInternally(type === 'shop' ? 'shopGrid' : 'give');
							Store.emit(actions.HIDE_MODAL);
						}}
					>
						{cta}
					</Button>
					<img src={imgSrc} class={s.cornerImg} alt={imgAlt} />
				</div>
			</div>
		);
	}
}
